import utils from '../utils/index'

export default function pannable(el, onPan, onPanStart, onPanEnd) {
  let panOrig, panLastPosition, panning, panningTarget, panOffset

  function handleMouseDown(e) {
    let el = utils.closest(e.target, ".pannable");

    if (el) {
      e.preventDefault()
      panOrig = {
        x: e.clientX,
        y: e.clientY
      };
      panLastPosition = {
        x: e.clientX,
        y: e.clientY
      };
      let box = el.getBoundingClientRect()
      panOffset = {
        x: box.left + box.width / 2 - e.clientX,
        y: box.top + box.height / 2 - e.clientY
      }
      panningTarget = el
      document.addEventListener("mousemove", handleMouseMove, false);
      document.addEventListener("mouseup", handleMouseUp, false);
    }

  }

  function handleMouseMove(e) {
    if (
      (!panning)
      &&
      Math.max(
        Math.abs(panOrig.x - e.clientX),
        Math.abs(panOrig.y - e.clientY)
      ) > 2) {
      panning = true;

      let el = panningTarget

      onPanStart(e.clientX, e.clientY, e, panningTarget, panOffset);
      return;
    }

    if (panning) {
      let dx = e.clientX - panLastPosition.x
        , dy = e.clientY - panLastPosition.y;
      panLastPosition = {
        x: e.clientX,
        y: e.clientY
      }
      onPan(dx, dy, e.clientX, e.clientY, e, panningTarget, panOffset);
    }
  }

  function handleMouseUp(e) {
    panOrig = { x: 0, y: 0 }
    document.removeEventListener("mousemove", handleMouseMove, false);
    document.removeEventListener("mouseup", handleMouseUp, false);
    if (panning) {
      onPanEnd(e, panningTarget);
    }
    panning = false;
  }

  el.addEventListener("mousedown", handleMouseDown, false)

  return function unpannable() {
    el.removeEventListener("mousedown", handleMouseDown, false)
  }
}




// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/pannable/index.js